import { Chart } from "@scuf/charts";
import { Card } from "@scuf/common";
import { useEffect, useState } from "react";
import { TostadorFetching } from "../../../class/fetchTostador";
import { plotBackground } from "../../../config/colors";
import { useDate } from "../../../hooks/useDate";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";

export default function TotalizadorAguaRecupConcentradora() {
  const initialFetch = new TostadorFetching().setIdSeccion(2).setSecuencia(9);

  const defaultObject = Object.assign({
    value: [],
    fecha: [],
  });

  // Custom hook que nos ayuda a extraer la fecha inicial y final
  const { setDateHook, fullDate } = useDate();

  const [totalizadorAguaRecupETP, setTotalizadorAguaRecupETP] =
    useState(defaultObject);
  const [totalizadorAguaRecupETPTurnoA, setTotalizadorAguaRecupETPTurnoA] =
    useState(defaultObject);
  const [totalizadorAguaRecupETPTurnoB, setTotalizadorAguaRecupETPTurnoB] =
    useState(defaultObject);

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
      const { data } = await getValoresPeriodo(initialFetch);

      populateTotalizadorAguaRecupETP(data);
      populateTotalizadorAguaRecupTurnoA(data);
      populateTotalizadorAguaRecupTurnoB(data);
      setDateHook(data, "Totalizador Agua Recuperada ETP Turno B");
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateTotalizadorAguaRecupETP(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Totalizador Agua Recuperada ETP"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setTotalizadorAguaRecupETP({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTotalizadorAguaRecupTurnoA(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Totalizador Agua Recuperada ETP Turno A"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setTotalizadorAguaRecupETPTurnoA({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTotalizadorAguaRecupTurnoB(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Totalizador Agua Recuperada ETP Turno B"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setTotalizadorAguaRecupETPTurnoB({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  return (
    <>
      <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Totalizador Agua Recuperada a Concentradora"}
            subtitle={"Periodo " + fullDate()}
          >
            {/** -------------------------------- Totalizador Agua Recuperada ETP --------------------------------------- */}
            <Chart.Area
              name="Totalizador Agua Recuperada ETP"
              data={totalizadorAguaRecupETP.value}
              yAxis={0}
            />

            {/** -------------------------------- Totalizador Agua Recuperada ETP Turno A --------------------------------------- */}
            <Chart.Area
              name="Totalizador Agua Recuperada ETP Turno A"
              data={totalizadorAguaRecupETPTurnoA.value}
              yAxis={0}
            />

            {/** -------------------------------- Totalizador Agua Recuperada ETP Turno B --------------------------------------- */}
            <Chart.Area
              name="Totalizador Agua Recuperada ETP Turno B"
              data={totalizadorAguaRecupETPTurnoB.value}
              yAxis={0}
            />

            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={totalizadorAguaRecupETP.fecha} />

            <Chart.YAxis
              labelSuffix=" m3"
              title="Caudal Día, m3"
              lineWidth={2}
              lineColor="white"
            />

          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
